module.exports = __webpack_public_path__ + "4b48abb92d833aa6ee80155237d38f88.svg";